import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import GenericLink from 'components/GenericLink';
import {browserHistory} from 'react-router';
import React, {useCallback} from 'react';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';

export function navToLiveCoachingCall(call, reviewId) {
  if (reviewId) {
    CoachingReviewActions.setViewingScorecardForReview(call.id, reviewId);
  }

  browserHistory.push({
    pathname: '/scorecard',
    query: {
      fileUploadId: call.id,
      suppressWaveform: true,
      readonly: true,
    },
  });
}

const wordBreak = {
  wordBreak: 'break-word',
};

const CallLink = ({call, reviewFileUpload, planId, reviewId, ...props}) => {
  // if we were sent planid/reviewid - we'll be popping open the coaching drawer.
  // make sure we send that along in the browserHistory call
  const goingToCoachingDrawer = planId && reviewId;

  const goToCall = useCallback(() => {
    const linkState = goingToCoachingDrawer && {
      planId,
      reviewId,
    };

    if (goingToCoachingDrawer) {
      CoachingPlaylistActions.hide();
    }
    browserHistory.push({pathname: `/call/${call.id}`, state: linkState});
  }, [call, goingToCoachingDrawer, planId, reviewId]);

  if (!call) return null;

  if (call.isMetadataOnly()) {
    if (reviewFileUpload.livecoaching) {
      const name = call.description === 'Call' ? 'Live Coaching' : call.description;
      return (
        <GenericLink {...props} onClick={() => navToLiveCoachingCall(call, reviewId)}>
          <span style={wordBreak}>{name}</span>
        </GenericLink>
      );
    }

    return (
      <span {...props}>
        <GenericTooltip hoverBehavior tooltip="EV doesn't have the call recording yet.">
          <p style={wordBreak}>{call.description}</p>
        </GenericTooltip>
      </span>
    );
  }

  return (
    <GenericLink {...props} onClick={goToCall}>
      <span style={wordBreak}>{call.description}</span>
    </GenericLink>
  );
};

export default CallLink;
